
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ybgQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $04xaX = parcelRequire("04xaX");


var $iDrrr = parcelRequire("iDrrr");


var $31fUM = parcelRequire("31fUM");

const $838e026edc294e9f$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)(function MentionItem(props) {
    const { eventHandlers: eventHandlers, id: id, mentionNodeDataProvider: mentionNodeDataProvider, providers: providers, text: text, accessLevel: accessLevel, localId: localId, userType: userType } = props;
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...inlineAnnotationProps,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $04xaX.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            providers: providers,
            localId: localId,
            mentionNodeDataProvider: mentionNodeDataProvider,
            userType: userType,
            eventHandlers: eventHandlers && eventHandlers.mention
        })
    }));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $04xaX.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        mentionNodeDataProvider: mentionNodeDataProvider,
        userType: userType,
        eventHandlers: eventHandlers && eventHandlers.mention
    });
});
var $838e026edc294e9f$export$2e2bcd8739ae039 = $838e026edc294e9f$var$_default_1;
module.exports["default"] = $838e026edc294e9f$export$2e2bcd8739ae039;

});

parcelRegister("31fUM", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $iDrrr = parcelRequire("iDrrr");


var $hZmcT = parcelRequire("hZmcT");

function $1e80a135c5761dad$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $hZmcT.useAnnotationRangeState)();
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}
module.exports["useInlineAnnotationProps"] = $1e80a135c5761dad$export$11564cda945bb3c9;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("etJ6B", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $aebd7c0b6385469e$var$BADGE_VISIBILITY_BREAKPOINT = 200;
const $aebd7c0b6385469e$var$containerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $aebd7c0b6385469e$var$hackedZIndexStyles = (0, $buxP3.xcss)({
    zIndex: '1'
});
const $aebd7c0b6385469e$var$resizeOffsetStyles = (0, $buxP3.xcss)({
    right: 'space.150'
});
const $aebd7c0b6385469e$var$getBadgeVisible = (width, height)=>{
    return width && width < $aebd7c0b6385469e$var$BADGE_VISIBILITY_BREAKPOINT || height && height < $aebd7c0b6385469e$var$BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $aebd7c0b6385469e$export$d7fda18776ad9a8d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let { children: children, element: element, width: width, height: height, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: t1 } = t0;
    const useMinimumZIndex = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== height || $[1] !== width) {
        t2 = $aebd7c0b6385469e$var$getBadgeVisible(width, height);
        $[0] = height;
        $[1] = width;
        $[2] = t2;
    } else t2 = $[2];
    const [visible, setVisible] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[3] !== element) {
        t3 = ()=>{
            const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
                const [entry] = entries;
                const { width: width_0, height: height_0 } = entry.contentRect;
                setVisible($aebd7c0b6385469e$var$getBadgeVisible(width_0, height_0));
            }));
            if (element) observer.observe(element);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            element
        ];
        $[3] = element;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof children === "function") {
        let t5;
        if ($[6] !== children || $[7] !== visible) {
            t5 = children({
                visible: visible
            });
            $[6] = children;
            $[7] = visible;
            $[8] = t5;
        } else t5 = $[8];
        children = t5;
    }
    if (!(0, $iDrrr.fg)("media-perf-uplift-mutation-fix")) {
        if (!element || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    const t5 = useMinimumZIndex && $aebd7c0b6385469e$var$hackedZIndexStyles;
    const t6 = extendedResizeOffset && $aebd7c0b6385469e$var$resizeOffsetStyles;
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = [
            $aebd7c0b6385469e$var$containerStyles,
            t5,
            t6
        ];
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== children || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
            as: "div",
            testId: "media-badges",
            "data-media-badges": "true",
            contentEditable: false,
            xcss: t7,
            children: children
        });
        $[12] = children;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, element: element, width: width, height: height, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $cozmU.useState)($aebd7c0b6385469e$var$getBadgeVisible(width, height));
    (0, $cozmU.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
            const [entry] = entries;
            const { width: width_0, height: height_0 } = entry.contentRect;
            setVisible($aebd7c0b6385469e$var$getBadgeVisible(width_0, height_0));
        }));
        if (element) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!element || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $aebd7c0b6385469e$var$containerStyles,
            useMinimumZIndex && $aebd7c0b6385469e$var$hackedZIndexStyles,
            extendedResizeOffset && $aebd7c0b6385469e$var$resizeOffsetStyles
        ],
        children: children
    });
};
module.exports["BlockNodeBadges"] = $aebd7c0b6385469e$export$d7fda18776ad9a8d;

});

parcelRegister("cLgZp", function(module, exports) {
const $01246376cedc8400$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["isPromise"] = $01246376cedc8400$export$4369c812aac99591;

});

parcelRegister("8auAj", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $34b824decffaa688$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).NONE];
}
module.exports["isRestricted"] = $34b824decffaa688$export$dbaa15dc1820b89a;

});

parcelRegister("j1Rvl", function(module, exports) {
parcelRequire("cozmU");


var $92AHJ = parcelRequire("92AHJ");


var $7n3BL = parcelRequire("7n3BL");

const $878ccfcc8552aaa6$export$98e06fe7a6174253 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).differentText);
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("7n3BL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
module.exports["propFormatter"] = $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50;

});

parcelRegister("21cx5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hI76F = parcelRequire("hI76F");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages,
            children: children
        });
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages,
        children: children
    });
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("hI76F", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $27fa02be5ce1169a$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("hqKAV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("hZBvY")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("bKkYT")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("35vun")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("feSXU")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("ejFse")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("ijMmr")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("3MV0X")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("iEpiF")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("ilr1n")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("g0oFy")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("2tmS1")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("37leR")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("9w6w2")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("1XXvL")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("l1Sln")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("aZHXV")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("8Ul7q")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("9nRMt")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("3VJWA")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("4150a")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("iOI3D")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("d8i36")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $27fa02be5ce1169a$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $27fa02be5ce1169a$export$d0a3169680473b6c;

});

parcelRegister("hqKAV", function(module, exports) {

let $cb090215aa1c7244$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cb090215aa1c7244$var$load("1JYrd"),
    $cb090215aa1c7244$var$load("cip6w"),
    $cb090215aa1c7244$var$load("gAG2n"),
    $cb090215aa1c7244$var$load("3feYV"),
    $cb090215aa1c7244$var$load("cwjU2"),
    $cb090215aa1c7244$var$load("3Ff1R"),
    $cb090215aa1c7244$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("hZBvY", function(module, exports) {

let $d1953bd3a2974a48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d1953bd3a2974a48$var$load("30242"),
    $d1953bd3a2974a48$var$load("3qBwQ"),
    $d1953bd3a2974a48$var$load("cYGDU"),
    $d1953bd3a2974a48$var$load("7Q1SM"),
    $d1953bd3a2974a48$var$load("33Iaa"),
    $d1953bd3a2974a48$var$load("blA7x"),
    $d1953bd3a2974a48$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("bKkYT", function(module, exports) {

let $88d44407619f68d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $88d44407619f68d3$var$load("15aAJ"),
    $88d44407619f68d3$var$load("8rREG"),
    $88d44407619f68d3$var$load("dgXJL"),
    $88d44407619f68d3$var$load("7JdzX"),
    $88d44407619f68d3$var$load("6681T"),
    $88d44407619f68d3$var$load("3dn3H"),
    $88d44407619f68d3$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("35vun", function(module, exports) {

let $23fa43cac21f66f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $23fa43cac21f66f7$var$load("l5BBd"),
    $23fa43cac21f66f7$var$load("93ASN"),
    $23fa43cac21f66f7$var$load("htu5t"),
    $23fa43cac21f66f7$var$load("24LNf"),
    $23fa43cac21f66f7$var$load("iYQCc"),
    $23fa43cac21f66f7$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("feSXU", function(module, exports) {

let $b182cccc51a21da0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b182cccc51a21da0$var$load("bbv9t"),
    $b182cccc51a21da0$var$load("9fQoJ"),
    $b182cccc51a21da0$var$load("lTboH"),
    $b182cccc51a21da0$var$load("cnlNg"),
    $b182cccc51a21da0$var$load("d3Phe"),
    $b182cccc51a21da0$var$load("lASLx"),
    $b182cccc51a21da0$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("ejFse", function(module, exports) {

let $a6c2fefec1957a21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6c2fefec1957a21$var$load("7p4je"),
    $a6c2fefec1957a21$var$load("8SZbD"),
    $a6c2fefec1957a21$var$load("iE05k"),
    $a6c2fefec1957a21$var$load("9Uf61"),
    $a6c2fefec1957a21$var$load("3Yk1e"),
    $a6c2fefec1957a21$var$load("5lJyy"),
    $a6c2fefec1957a21$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("ijMmr", function(module, exports) {

let $d55f83d4930a3a37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d55f83d4930a3a37$var$load("5ZQnr"),
    $d55f83d4930a3a37$var$load("lJyww"),
    $d55f83d4930a3a37$var$load("2hqQb"),
    $d55f83d4930a3a37$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("3MV0X", function(module, exports) {

let $2c2214ae0b7fe6c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c2214ae0b7fe6c5$var$load("1jQRQ"),
    $2c2214ae0b7fe6c5$var$load("5pOQA"),
    $2c2214ae0b7fe6c5$var$load("5GSny"),
    $2c2214ae0b7fe6c5$var$load("fJSEb"),
    $2c2214ae0b7fe6c5$var$load("ajzkj"),
    $2c2214ae0b7fe6c5$var$load("eyysG"),
    $2c2214ae0b7fe6c5$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("iEpiF", function(module, exports) {

let $d93f96799db33c2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d93f96799db33c2c$var$load("km37l"),
    $d93f96799db33c2c$var$load("gbksI"),
    $d93f96799db33c2c$var$load("j2X7f"),
    $d93f96799db33c2c$var$load("9TeWr"),
    $d93f96799db33c2c$var$load("kUZ7k"),
    $d93f96799db33c2c$var$load("dJQL7"),
    $d93f96799db33c2c$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("ilr1n", function(module, exports) {

let $d5af25feeea858f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5af25feeea858f7$var$load("lTbXI"),
    $d5af25feeea858f7$var$load("a98cw"),
    $d5af25feeea858f7$var$load("e40mE"),
    $d5af25feeea858f7$var$load("fOGnR"),
    $d5af25feeea858f7$var$load("cDQOq"),
    $d5af25feeea858f7$var$load("8upye"),
    $d5af25feeea858f7$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("g0oFy", function(module, exports) {

let $ba6fc83991d24911$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ba6fc83991d24911$var$load("iUyZj"),
    $ba6fc83991d24911$var$load("4PDaO"),
    $ba6fc83991d24911$var$load("lMhbw"),
    $ba6fc83991d24911$var$load("8nEeY"),
    $ba6fc83991d24911$var$load("kLZKK"),
    $ba6fc83991d24911$var$load("c7GMc"),
    $ba6fc83991d24911$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("2tmS1", function(module, exports) {

let $1cd007cc20d329a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1cd007cc20d329a6$var$load("kPlMQ"),
    $1cd007cc20d329a6$var$load("ervs7"),
    $1cd007cc20d329a6$var$load("8CX31"),
    $1cd007cc20d329a6$var$load("fzzMQ"),
    $1cd007cc20d329a6$var$load("33S6H"),
    $1cd007cc20d329a6$var$load("kFae4"),
    $1cd007cc20d329a6$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("37leR", function(module, exports) {

let $24528016eeb341d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $24528016eeb341d6$var$load("iT2sv"),
    $24528016eeb341d6$var$load("iMMtn"),
    $24528016eeb341d6$var$load("23VWs"),
    $24528016eeb341d6$var$load("3gNEO"),
    $24528016eeb341d6$var$load("93obY"),
    $24528016eeb341d6$var$load("6Y9jE"),
    $24528016eeb341d6$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("9w6w2", function(module, exports) {

let $6edc281a2e3b62b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6edc281a2e3b62b4$var$load("lyPpF"),
    $6edc281a2e3b62b4$var$load("eX5n7"),
    $6edc281a2e3b62b4$var$load("aiYuN"),
    $6edc281a2e3b62b4$var$load("gvylW"),
    $6edc281a2e3b62b4$var$load("bxfRe"),
    $6edc281a2e3b62b4$var$load("ed6s8"),
    $6edc281a2e3b62b4$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("1XXvL", function(module, exports) {

let $16e976d9b17d9754$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $16e976d9b17d9754$var$load("iN3cj"),
    $16e976d9b17d9754$var$load("3nHdy"),
    $16e976d9b17d9754$var$load("gDEvm"),
    $16e976d9b17d9754$var$load("80OLx"),
    $16e976d9b17d9754$var$load("1EVcg"),
    $16e976d9b17d9754$var$load("96q1k"),
    $16e976d9b17d9754$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("l1Sln", function(module, exports) {

let $f4f3d883a1d74d7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f4f3d883a1d74d7d$var$load("eC1OL"),
    $f4f3d883a1d74d7d$var$load("ilL9c"),
    $f4f3d883a1d74d7d$var$load("64nco"),
    $f4f3d883a1d74d7d$var$load("e4s0V"),
    $f4f3d883a1d74d7d$var$load("28EXy"),
    $f4f3d883a1d74d7d$var$load("7RZp5"),
    $f4f3d883a1d74d7d$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("aZHXV", function(module, exports) {

let $8011b48931b826fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8011b48931b826fd$var$load("4NJ49"),
    $8011b48931b826fd$var$load("bfOZL"),
    $8011b48931b826fd$var$load("jLbRX"),
    $8011b48931b826fd$var$load("4dPO1"),
    $8011b48931b826fd$var$load("gg8tK"),
    $8011b48931b826fd$var$load("eF54W"),
    $8011b48931b826fd$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("8Ul7q", function(module, exports) {

let $67c3ef6c1d579887$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $67c3ef6c1d579887$var$load("fsCDU"),
    $67c3ef6c1d579887$var$load("kuolm"),
    $67c3ef6c1d579887$var$load("apVmx"),
    $67c3ef6c1d579887$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("9nRMt", function(module, exports) {

let $6d4ffacd299246a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6d4ffacd299246a9$var$load("g9gkE"),
    $6d4ffacd299246a9$var$load("jYdbS"),
    $6d4ffacd299246a9$var$load("6ncWv"),
    $6d4ffacd299246a9$var$load("ltrgi"),
    $6d4ffacd299246a9$var$load("fu25G"),
    $6d4ffacd299246a9$var$load("iQGcz"),
    $6d4ffacd299246a9$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("3VJWA", function(module, exports) {

let $2dca557ccc009e9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2dca557ccc009e9d$var$load("jhikU"),
    $2dca557ccc009e9d$var$load("f0i3H"),
    $2dca557ccc009e9d$var$load("bvBAp"),
    $2dca557ccc009e9d$var$load("69YlM"),
    $2dca557ccc009e9d$var$load("cyTsc"),
    $2dca557ccc009e9d$var$load("kXCsp"),
    $2dca557ccc009e9d$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("4150a", function(module, exports) {

let $2ecb22ac2e9ca9a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2ecb22ac2e9ca9a4$var$load("fSsz4"),
    $2ecb22ac2e9ca9a4$var$load("kWOpS"),
    $2ecb22ac2e9ca9a4$var$load("9tUAi"),
    $2ecb22ac2e9ca9a4$var$load("kgHzZ"),
    $2ecb22ac2e9ca9a4$var$load("j4ur8"),
    $2ecb22ac2e9ca9a4$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("iOI3D", function(module, exports) {

let $db2f12754626290c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db2f12754626290c$var$load("d91RK"),
    $db2f12754626290c$var$load("f7hfJ"),
    $db2f12754626290c$var$load("QI1kr"),
    $db2f12754626290c$var$load("brdRT"),
    $db2f12754626290c$var$load("lWBlc"),
    $db2f12754626290c$var$load("s2EmI"),
    $db2f12754626290c$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("d8i36", function(module, exports) {

let $98fa05e5383d8189$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $98fa05e5383d8189$var$load("708J7"),
    $98fa05e5383d8189$var$load("kVqUf"),
    $98fa05e5383d8189$var$load("2IMxh"),
    $98fa05e5383d8189$var$load("j03Pa"),
    $98fa05e5383d8189$var$load("kke1I"),
    $98fa05e5383d8189$var$load("gOwMq"),
    $98fa05e5383d8189$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});


//# sourceMappingURL=mention.099d8ded.js.map
